import { render, staticRenderFns } from "./pin.vue?vue&type=template&id=47ad88c4"
import script from "./pin.vue?vue&type=script&lang=js"
export * from "./pin.vue?vue&type=script&lang=js"
import style0 from "../../mixins.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports